import "./App.css";

function App() {
  return (
    <div className="App">
      <div id="eid-greetings">
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>

        <div class="eid-greetings">
          <div class="typography">
            <div class="container-outer">
              <div class="container">
                <div class="main-text">
                  <div class="top">
                    <p>EID</p>
                  </div>
                  <div class="bottom">
                    <p>EID</p>
                  </div>

                  <div class="sub-text">
                    <p>mubarak</p>
                  </div>
                  <div class="date">
                    <p>2023</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <p class="left">...جنيد</p>
      </footer>
    </div>
  );
}

export default App;
